import { ActivatedRouteSnapshot, ResolveFn, RouterStateSnapshot } from "@angular/router";
import { Country } from "../model/country";
import { inject } from "@angular/core";
import { CountryService } from "../services/country.service";

export const countryResolver: ResolveFn<Country[]> = (route: ActivatedRouteSnapshot, state: RouterStateSnapshot) => {
    const countryService = inject(CountryService);
    return countryService.getAll();
}